import { FormControl } from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import WalkInHelperText from "./WalkInHelperText";

function WalkInTimePicker({
  name,
  handleBlur,
  value,
  helperText,
  errors,
  setFieldValue,
}) {
  return (
    <FormControl fullWidth>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          name={name}
          onBlur={handleBlur}
          value={dayjs(value)}
          onChange={(e) => {
            setFieldValue(name, dayjs(e).format());
          }}
        />
      </LocalizationProvider>
      <WalkInHelperText helperText={helperText} errors={errors} />
    </FormControl>
  );
}

export default WalkInTimePicker;
